<template>
  <v-card class="pa-12" elevation="12" :loading="pending" max-width="50vw" min-height="100%">
    <!-- Login Failed -->
    <template v-if="error">
      <v-card-title class="text-error">
        {{ $t('LoginFailed') }}
      </v-card-title>
      <v-card-text>
        <span v-html="String(error)" />
      </v-card-text>

      <v-card-actions class="justify-center">
        <v-btn :to="{ name: Routes.auth_login }" variant="plain" prepend-icon="mdi-arrow-left">
          {{ $t('LoginSamlBack') }}
        </v-btn>
      </v-card-actions>
    </template>

    <!-- Login Pending -->
    <template v-else-if="pending">
      <v-card-text>{{ $t('LoginPending') }}</v-card-text>
    </template>

    <!-- Login Success -->
    <template v-else>
      <v-card-subtitle>
        {{ $t('LoginSuccess') }}
      </v-card-subtitle>
      <v-card-title v-if="useUser.user.value">
        {{ $t('LoginWelcome', { user: useUser.user.value.name }) }}
      </v-card-title>
      <v-card-text class="text-center py-16">
        {{ $t('LoginSuccessRedirect') }}
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn block :to="redirect" variant="text">
          {{ $t('LoginSuccessRedirectInCaseNot') }}
        </v-btn>
      </v-card-actions>
    </template>
  </v-card>
</template>

<script lang="ts">
import JsCookie from 'js-cookie'
import { defineComponent } from 'vue'
import useUser from '~/composables/useUser'
import { definePageMeta } from '#imports'
import { navigateTo } from 'nuxt/app'
import { GuestMode } from '~/lib/auth'
import { Routes } from '~/_routes'
import { Notify } from '~/lib/notify'
import { wait } from '~/helper'

export default defineComponent({
  name: 'SamlJwtPage',
  setup() {
    definePageMeta({
      auth: GuestMode,
    })
    return { useUser: useUser(), Routes }
  },

  data() {
    return {
      token: null as string | null,
      pending: true,
      error: null as Error | string | null,
    }
  },

  computed: {
    redirect() {
      return JsCookie.get('redirect') || { name: Routes.index }
    },
  },

  mounted() {
    this.handleMount()
  },

  methods: {
    async handleMount() {
      // Handle server error
      const serverError = this.$route.query.error
      if (serverError) {
        this.error = this.$t('ErrorServer', {
          error: Array.isArray(serverError) ? serverError.join(', ') : serverError,
        }) as string
        this.pending = false
        return
      }

      // Get token & redirect from cookies
      this.token = JsCookie.get('access_token') || null
      if (!this.token) {
        this.error = new Error(this.$t('LoginJWTMissing') as string)
        this.pending = false
        return
      }
      try {
        // Sets token, fetch user, redirect
        this.useUser.authState.setToken(this.token)
        this.useUser.auth.getSession()
        wait(1000, () => navigateTo(this.redirect))

        Notify.success(this.$t('LoginSuccess'))

        // Notify token expiration
        this.useUser.notifyTokenExpiration()
        this.useUser.checkUsersTimeout()
      } catch (e) {
        this.error = e as Error
      } finally {
        this.pending = false
      }
    },
  },
})
</script>
